import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Switch } from '@mui/material';
import ConfigCard from './ConfigCard';
import { PdiRow } from './_PdiHelpers';

const StockAvailabilityCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb) => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (v) => onChange && onChange(k, v);

    const enabled = get('showStockByStore', true);

    return (
        <ConfigCard
            anchor="cfg-card-pdi-stock"
            title={tr('cfg_pdi_stock_title', 'Stock & store availability')}
            description={tr('cfg_pdi_stock_desc', 'Information about which physical stores still have the product.')}
            theme={theme}
        >
            <Stack spacing={1}>
                {/* SHOW_AVAILABLE_STOCK: also decides whether a size that is out of
                    stock can still go into the cart (it can when this is off). */}
                <PdiRow
                    label={tr('cfg_pdi_stock_status', 'Show the stock status of the product')}
                    help={tr('cfg_pdi_stock_status_help', 'Shows which sizes are still in stock. When off, customers can add sizes that are out of stock to their cart — only advisable when the shop works with pickups only.')}
                    control={
                        <Switch
                            color="success"
                            size="small"
                            checked={!!get('showStockStatus', true)}
                            onChange={(e) => set('showStockStatus')(e.target.checked)}
                        />
                    }
                />
                <PdiRow
                    label={tr('cfg_pdi_stock_show', 'Show in which stores the product is in stock')}
                    control={
                        <Switch
                            color="success"
                            size="small"
                            checked={!!enabled}
                            onChange={(e) => set('showStockByStore')(e.target.checked)}
                        />
                    }
                />
                {/* Nested sub-toggle — only meaningful when the parent is on. */}
                <Box sx={{ opacity: enabled ? 1 : 0.5, pointerEvents: enabled ? 'auto' : 'none' }}>
                    <PdiRow
                        indent
                        label={tr('cfg_pdi_stock_hide_unknown', 'Hide store status when size is unknown')}
                        help={tr('cfg_pdi_stock_hide_unknown_help', "Don't show stock status for stores where the chosen size is not tracked")}
                        control={
                            <Switch
                                color="success"
                                size="small"
                                checked={!!get('hideWhenSizeUnknown')}
                                onChange={(e) => set('hideWhenSizeUnknown')(e.target.checked)}
                            />
                        }
                    />
                </Box>
            </Stack>
        </ConfigCard>
    );
};

StockAvailabilityCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default StockAvailabilityCard;
